export const SCROLL_CONTAINER_ID = "scroll-container";
//# sourceMappingURL=ui.js.map